module.exports = __webpack_public_path__ + "img/veggie-taco-salad.b8caa0ce.jpg";